export default __webpack_public_path__ + "static/media/road_trip_premium_logo.2cdaa4a5.svg";